import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import MapVisualMultiple from './MapVisualMultiple';
import BuildingListRail, { buildingKey } from './BuildingListRail';

// Map + (optionally) its own building list, same layout for the inline
// landing-page view and the fullscreen modal, just a different bounding
// height. Marker clicks highlight the list instead of popping up a card
// (when a list is shown here at all — see showSidebar below).
function BuildingMapLayout({ allBuildings, highlightedKey, setHighlightedKey, onSelectBuilding, onToggleMainBuilding, mapHeight, onRequestFullscreen, showSidebar, showExtraControls }) {
  return (
    // align-items: flex-start (not the flex default of stretch) — the map
    // side sizes itself naturally (canvas + controls row) with no scroll
    // of its own; only the building list gets a cap, via maxHeight (not
    // height, which would force it to fill empty space when short) so a
    // long list scrolls inside the sidebar instead of growing the whole
    // row to match it.
    <div className="d-flex align-items-start" style={{ minWidth: 0 }}>
      {showSidebar && (
        // BuildingListRail itself is width-agnostic (fills its container) —
        // this wrapper is what gives it its fixed sidebar width here, next
        // to the map's flex-grow-1 column.
        <div className="d-none d-md-block" style={{ width: 260, flexShrink: 0 }}>
          <BuildingListRail allBuildings={allBuildings} highlightedKey={highlightedKey} setHighlightedKey={setHighlightedKey}
            onSelectBuilding={onSelectBuilding} onToggleMainBuilding={onToggleMainBuilding} maxHeight={mapHeight} />
        </div>
      )}
      <div className="flex-grow-1" style={{ minWidth: 0 }}>
        <MapVisualMultiple height={mapHeight} onRequestFullscreen={onRequestFullscreen} highlightedBuildingKey={highlightedKey}
          onMarkerClick={(rakennus) => setHighlightedKey(buildingKey(rakennus))} showExtraControls={showExtraControls} />
      </div>
    </div>
  );
}

// EXPERIMENTAL: the big sidebar+map view (normally only reachable via
// the fullscreen modal) rendered directly on the landing page instead of
// the small embedded map — user asked to preview this in place before
// deciding whether to keep it. The fullscreen button still opens the
// same layout even bigger (true fullscreen Modal), in case the bounded
// inline height isn't enough.
//
// highlightedKey/setHighlightedKey are controlled by the caller (not
// owned here) — KiinteistoDetails.jsx now also has its own page-wide
// BuildingListRail (option 2 of the landing-page redesign), and both
// that rail and this map need to share one "currently focused building"
// instead of tracking it separately.
export default function MapVisualMultipleModalWrapper({
  onSelectBuilding, onToggleMainBuilding, allBuildings,
  highlightedKey, setHighlightedKey,
  showSidebar = true, mapHeight = '440px',
}) {
  const [showMapModal, setShowMapModal] = useState(false);

  const sharedProps = { allBuildings, highlightedKey, setHighlightedKey, onSelectBuilding, onToggleMainBuilding };

  return (
    <>
      <div className="bg-white shadow-sm" style={{ maxWidth: '100%', boxShadow: '0 4px 8px rgba(25, 135, 84, 0.2)' }}>
        <BuildingMapLayout {...sharedProps} mapHeight={mapHeight} showSidebar={showSidebar} showExtraControls={false} onRequestFullscreen={() => setShowMapModal(true)} />
      </div>

      {/* No breakpoint suffix (unlike every other fullscreen modal in
          this codebase, which uses "md-down" as a mobile-only fallback)
          — here the whole point is a bigger view on any screen size,
          triggered explicitly by the button above. Always shows its own
          sidebar regardless of the embedded view's showSidebar — this is
          the self-contained "pop out bigger" view. */}
      <Modal show={showMapModal} onHide={() => setShowMapModal(false)} fullscreen>
        <Modal.Header closeButton>
          <Modal.Title className="text-success">Karttanäkymä</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <BuildingMapLayout {...sharedProps} mapHeight="calc(100vh - 160px)" showSidebar showExtraControls />
        </Modal.Body>
      </Modal>
    </>
  );
}
